import React from "react";
import {
  Button,
  FormGroup,
  Stack,
  TextField,
} from "@mui/material";

const LabelInput = ({ label, description, onChange, onSave, disabled }) => {
  const [focus, setFocus] = React.useState(false);
  const newLabel = (e) => {
    onChange(e.target.value, description);
  };

  const newDescription = (e) => {
    onChange(label, e.target.value);
  };

  // useEffect(() => {}, [label, keep]);

  return (
    <div>
      <FormGroup>
        <Stack direction="row" spacing={2}>
          <Stack direction="row" spacing={2}>
            <TextField
              label="Label"
              type="text"
              value={label}
              name="label"
              size="small"
              onChange={newLabel}
              style={{ width: 200 }}
            />
            <TextField
              label="Comments"
              style={{ width: focus ? 400 : 400 }}

              type="text"
              multiline
              size="small"
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              rows={focus ? 3 : 1}
              value={description}
              name="description"
              onChange={newDescription}

            />
          </Stack>
          <Stack spacing={2}>
            <Button variant="contained" disabled={disabled} onClick={onSave}>
              Save
            </Button>
          </Stack>
        </Stack>
      </FormGroup>
    </div>
  );
};

export default LabelInput;
